module.exports = __webpack_public_path__ + "static/media/file-minus.086b7df6.svg";